module.exports = __webpack_public_path__ + "static/media/m_faceshape_round.9c2050b3.png";